declare global {
  interface Window {
    __eweadnXingshanSdkChain?: Promise<unknown>;
    /** 已在串行队列内执行，嵌套调用须直跑 fn 避免死锁 */
    __eweadnXingshanSdkInOp?: boolean;
  }
}

/**
 * 星闪 v2 全应用唯一 HID 串行队列（主应用 Bridge + 键盘子应用灯光页须共用，否则并发 closeDevice/init）。
 */
export async function runSerializedXingshanSdkOp<T>(
  fn: () => Promise<T>
): Promise<T> {
  if (typeof window === "undefined") {
    return fn();
  }
  if (window.__eweadnXingshanSdkInOp) {
    return fn();
  }
  const prev = window.__eweadnXingshanSdkChain ?? Promise.resolve();
  const next = prev.then(async () => {
    window.__eweadnXingshanSdkInOp = true;
    try {
      return await fn();
    } finally {
      window.__eweadnXingshanSdkInOp = false;
    }
  });
  window.__eweadnXingshanSdkChain = next.then(
    () => undefined,
    () => undefined
  );
  return next;
}

/** 等待星闪 HID 串行队列排空（取消勾选/退出恢复前须先停掉在途律动帧） */
export async function waitForXingshanSdkChainIdle(
  timeoutMs?: number
): Promise<void> {
  if (typeof window === "undefined") return;
  const chain = window.__eweadnXingshanSdkChain;
  if (!chain) return;

  const waitChain = chain.then(
    () => undefined,
    () => undefined
  );

  if (timeoutMs != null && timeoutMs > 0) {
    let timer: ReturnType<typeof setTimeout> | undefined;
    try {
      await Promise.race([
        waitChain,
        new Promise<void>((resolve) => {
          timer = setTimeout(() => {
            console.warn(
              `[XingshanSdkQueue] 等待串行队列排空超时 (${timeoutMs}ms)，继续后续流程`
            );
            resolve();
          }, timeoutMs);
        }),
      ]);
    } finally {
      if (timer) clearTimeout(timer);
    }
    return;
  }

  try {
    await chain;
  } catch {
    // 前序下发失败不影响后续恢复
  }
}
